import {orderBy, uniqBy} from 'lodash'
import clsx from 'clsx'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(styles)

export default function References (props) {
  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {link, assessment, translate, action} = context
  const {references, withReferences} = props
  const sortedReferences = uniqBy(orderBy(references, ['sectionIndex', 'index']), s => `${s.sectionIndex}.${s.index}`)
  return (
    <Box className={classes.root}>
      <Box className={classes.label}>{translate('standard-references-label')}:</Box>
      <Box className={classes.references}>{sortedReferences.map((reference, index) => {
        const to = link('quiz', assessment, action, reference.section, reference.id)
        return withReferences 
          ? <Link key={index} className={clsx(classes.reference, classes.link)} to={to}>{reference.sectionIndex + 1}.{reference.index + 1}</Link>
          : <Box key={index} className={classes.reference}>{reference.sectionIndex + 1}.{reference.index + 1}</Box>
      })}
      </Box>
    </Box>
  )
}

function styles () {
  return {
    root: {
      display: 'flex'
    },
    label: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#3f5250',
      fontSize: '10pt',
      fontWeight: 'bold',
      fontStyle: 'oblique',
      marginBottom: 8
    },
    references: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    link: {
      "&:hover": {
        transform: 'scale(1.1)'
      }
    },
    reference: {
      color: '#fff',
      marginBottom: 8,
      marginLeft: 8,
      textDecoration: 'none',
      backgroundColor: '#1d9be5',
      padding: 4,
      borderRadius: 5,
      fontSize: '9pt',
    }
  }
}
